import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';

export default {
  name: 'GlobalTable',
  props: {
    headers: Array,
    data: Array,
    fields: Array,
    table_id: {
      type: String,
      default: 'global_table'
    }
  },
  mounted() {
    this.initialize_data_table();
  },
  methods: {
    initialize_data_table() {
      this.$nextTick(() => {
        const table_id = `#${this.table_id}`;
        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }

        if (this.data && this.data.length > 0) {
          $(table_id).DataTable({
            autoWidth: false,
            responsive: true,
            ordering: false,
            language: {
              info: "",
              lengthMenu: "_MENU_&nbsp;&nbsp; entries per page",
              emptyTable: ""
            }
          });
        }
      });
    }
  },
  watch: {
    data(new_data) {
      if (new_data && new_data.length > 0) {
        this.initialize_data_table();
      }
    }
  }
};
